import type { SunProtectionOrder } from "../order.types";
import {
    orderByIdResponseSchema,
    orderResponseSchema,
    sunProtectionOrderSchema,
} from "../schemas/order.schema";

export function parseSunProtectionOrder(
    raw: unknown,
): SunProtectionOrder | null {
    const result = sunProtectionOrderSchema.safeParse(raw);
    if (!result.success) return null;
    return result.data;
}

export function parseSunProtectionOrderResponse(
    raw: unknown,
): SunProtectionOrder | null {
    const result = orderResponseSchema.safeParse(raw);
    if (!result.success) return null;
    return result.data.getSunProtectionOrder ?? null;
}

export function parseSunProtectionOrderByIdResponse(
    raw: unknown,
): SunProtectionOrder | null {
    const result = orderByIdResponseSchema.safeParse(raw);
    if (!result.success) return null;
    return result.data.getSunProtectionOrderById ?? null;
}
